export function getHttpStatus(error) {
  if (error && error.response && error.response.status) {
    return error.response.status;
  }
  return null;
}

export function isAuthError(error) {
  const status = getHttpStatus(error);
  return status === 401 || status === 403;
}

export function isNetworkError(error) {
  if (!error) {
    return false;
  }
  if (!error.response) {
    return true;
  }
  return false;
}

export function shouldOfferRetry(error) {
  if (isAuthError(error)) {
    return false;
  }

  const status = getHttpStatus(error);
  if (status && status >= 400 && status < 500) {
    return false;
  }

  return isNetworkError(error) || (status && status >= 500);
}

export const RETRY_CANCELLED_MESSAGE = "Retry cancelled";

export function isRetryCancelled(error) {
  return (
    error &&
    (error.message === RETRY_CANCELLED_MESSAGE ||
      error === RETRY_CANCELLED_MESSAGE)
  );
}

export function getErrorMessage(error, fallback) {
  if (isAuthError(error)) {
    return "Your session has expired. Please log in again.";
  }

  if (isNetworkError(error)) {
    return fallback || "Please check your internet connection and try again.";
  }

  const status = getHttpStatus(error);
  if (status) {
    return `Request failed (${status}). Please try again.`;
  }

  return fallback || "Something went wrong. Please try again.";
}
